import * as addresses from './endpoints/addresses';
import * as authentication from './endpoints/authentication';
import * as baskets from './endpoints/baskets';
import * as behavioralDiscounts from './endpoints/behavioralDiscounts';
import * as bottomSheet from './endpoints/bottomSheet';
import * as brand from './endpoints/brand';
import * as dismissibleMessaging from './endpoints/dismissibleMessaging';
import * as experiments from './endpoints/experiments';
import * as favorites from './endpoints/favorites';
import * as featureFlags from './endpoints/featureFlags';
import * as grace from './endpoints/grace';
import * as home from './endpoints/home.js';
import * as idMeVerification from './endpoints/idMeVerification.js';
import * as mealAddons from './endpoints/mealAddons';
import * as mealAddonSelections from './endpoints/mealAddonSelections';
import * as mealNotes from './endpoints/mealNotes';
import * as meals from './endpoints/meals';
import * as mealSelections from './endpoints/mealSelections';
import * as menus from './endpoints/menus';
import * as menuSearch from './endpoints/menuSearch';
import * as nutritionalFacts from './endpoints/nutritionalFacts';
import * as offerRewards from './endpoints/offerRewards';
import * as optIns from './endpoints/optIns';
import * as optInSelections from './endpoints/optInSelections';
import * as partnerDeals from './endpoints/partnerDeals';
import * as pastReceipts from './endpoints/pastReceipts';
import * as pauseOfferRewards from './endpoints/pauseOfferRewards';
import * as pauseReasons from './endpoints/pauseReasons';
import * as previousBaskets from './endpoints/previousBaskets';
import * as promotions from './endpoints/promotions';
import * as quickFilters from './endpoints/quickFilters';
import * as recommendedMeals from './endpoints/recommendedMeals';
import * as restartCampaign from './endpoints/restartCampaign';
import * as reviewableMeals from './endpoints/reviewableMeals';
import * as reviews from './endpoints/reviews';
import * as sendABox from './endpoints/sendABox';
import * as shoppingListMeals from './endpoints/shoppingListMeals';
import * as signUp from './endpoints/signUp';
import * as streakOffers from './endpoints/streakOffers';
import * as suggestedPairings from './endpoints/suggestedPairings';
import * as user from './endpoints/user';
import * as userOffers from './endpoints/user_offers';
import * as userMessages from './endpoints/userMessages';
import * as basketsV3 from './endpoints/v3/baskets';
import * as mealBadgesV3 from './endpoints/v3/mealBadges';
import * as mealPricesV3 from './endpoints/v3/mealPrices';
import * as mealSelloutsV3 from './endpoints/v3/mealSellouts';
import * as menusV3 from './endpoints/v3/menus';
import * as quickFiltersV3 from './endpoints/v3/quickFilters';
import * as getCompletedReviewsV3 from './endpoints/v3/reviews';
import * as userV3 from './endpoints/v3/user';

export default {
  ...authentication,
  ...addresses,
  ...baskets,
  ...behavioralDiscounts,
  ...bottomSheet,
  ...brand,
  ...dismissibleMessaging,
  ...experiments,
  ...favorites,
  ...featureFlags,
  ...grace,
  ...idMeVerification,
  ...home,
  ...meals,
  ...mealAddons,
  ...mealAddonSelections,
  ...mealNotes,
  ...mealSelections,
  ...menus,
  ...menuSearch,
  ...nutritionalFacts,
  ...offerRewards,
  ...optIns,
  ...optInSelections,
  ...partnerDeals,
  ...pastReceipts,
  ...pauseOfferRewards,
  ...pauseReasons,
  ...previousBaskets,
  ...promotions,
  ...quickFilters,
  ...recommendedMeals,
  ...reviews,
  ...reviewableMeals,
  ...restartCampaign,
  ...sendABox,
  ...shoppingListMeals,
  ...signUp,
  ...streakOffers,
  ...suggestedPairings,
  ...user,
  ...userMessages,
  ...userOffers,
  v3: {
    ...basketsV3,
    ...menusV3,
    ...quickFiltersV3,
    ...userV3,
    ...mealSelloutsV3,
    ...mealBadgesV3,
    ...mealPricesV3,
    ...getCompletedReviewsV3,
  },
};
